import React, { useState, useEffect } from 'react';
import { getWeeklyTrends } from '../../services/api';

function WeeklySummary() {
  const [trends, setTrends] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadTrends();
  }, []);

  const loadTrends = async () => {
    try {
      const data = await getWeeklyTrends(4); // Last 4 weeks
      setTrends(data);
    } catch (error) {
      console.error('Error loading weekly trends:', error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return <div className="weekly-summary loading">Lade wöchentliche Zusammenfassung...</div>;
  }

  if (trends.length === 0) {
    return (
      <div className="weekly-summary empty">
        <p>Keine wöchentlichen Trends verfügbar.</p>
        <p>Führe das Trend-Calculation-Script aus, um Trends zu generieren.</p>
      </div>
    );
  }

  return (
    <div className="weekly-summary">
      <h3>Wöchentliche Zusammenfassung</h3>
      <div className="trends-table">
        <table>
          <thead>
            <tr>
              <th>Woche</th>
              <th>Gewichtsänderung</th>
              <th>Ø Defizit</th>
              <th>
                Abweichung{' '}
                <span title="Tatsächliche Abnahme minus erwartete Abnahme aus Kalorientracking. Positiv = mehr abgenommen als erwartet." style={{ cursor: 'help', opacity: 0.5, fontSize: '0.75em' }}>ⓘ</span>
              </th>
              <th>Datentage</th>
            </tr>
          </thead>
          <tbody>
            {trends.map((trend) => {
              const weekStart = new Date(trend.week_start_date);
              const weekLabel = `${weekStart.getDate()}.${weekStart.getMonth() + 1}.`;

              const today = new Date();
              today.setHours(0, 0, 0, 0);
              const weekEnd = new Date(trend.week_end_date);
              weekEnd.setHours(0, 0, 0, 0);
              const weekStartNorm = new Date(trend.week_start_date);
              weekStartNorm.setHours(0, 0, 0, 0);
              const totalDays = weekEnd < today
                ? 7
                : Math.floor((today - weekStartNorm) / 86400000) + 1;

              return (
                <tr key={trend.id}>
                  <td>{weekLabel}</td>
                  <td className={trend.weight_change_kg < 0 ? 'positive' : ''}>
                    {trend.weight_change_kg != null ? `${Number(trend.weight_change_kg).toFixed(2)} kg` : 'N/A'}
                  </td>
                  <td>{trend.avg_calorie_deficit ? `${trend.avg_calorie_deficit} kcal` : 'N/A'}</td>
                  <td className={trend.variance_kg != null && trend.variance_kg > 0 ? 'positive' : trend.variance_kg != null && trend.variance_kg < 0 ? 'negative' : ''}>
                    {trend.variance_kg != null ? `${Number(trend.variance_kg) > 0 ? '+' : ''}${Number(trend.variance_kg).toFixed(2)} kg` : 'N/A'}
                  </td>
                  <td>{trend.days_with_complete_data ?? 'N/A'}/{totalDays}</td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
      <p style={{ fontSize: '0.75rem', color: 'var(--text-secondary)', marginTop: '0.5rem', opacity: 0.7 }}>
        Abweichung = tatsächliche Abnahme − erwartete Abnahme (aus Ø Defizit). Positiv: mehr abgenommen als Tracking vorhersagte.
      </p>
    </div>
  );
}

export default WeeklySummary;
